export default {
  en: {
    admin: 'Administrator',
    email: 'Email',
    prenom: 'First name',
    nom: 'Last name',
    adresse: 'Address',
    ville: 'City',
    codePostal: 'Postal code',
    pays: 'Country',
    province: 'Province',
    etat: 'State',
    mobile: 'Mobile',
    telephone: 'Phone number',
    retourAccueil: 'Back to home',
    accueil: 'Home',
    aPropos: 'About',
    infoDC:
      'Please note that registration for community distribution is closed for this year.',
    mesCoupons: 'My coupons (community distribution)',
    mesPermis: 'My licences (hunting and fishing)',
    commanderPermis: 'Order confirmation',
    distributionCommunautaire: 'Community distribution',
    updateProfile: 'Update my profile',
    inscriptionAssemblee: 'Registration form for the general meeting',
    espaceVideo: 'Video space',
    elections: 'Elections',
    reponsesCandidatsElections: 'Candidates answers',
    monCouponPromo: 'My promo code',
    importationCouponsPromo: 'Import promo coupons',
    monProfil: 'My profile',
    deconnexion: 'Log out',
    confirmationCommande: 'Order confirmation',
    merci: 'Thank you',
    erreurPaiement:
      'An error has occurred, please contact a member of our team.',
    noCertificat: 'Hunter certificate number',
    noCodeCertificat: 'Code appearing on the hunter certificate',
    erreurNoCertificat: 'Please enter a certificate number.',
    erreurNoCodeCertificat: 'Please enter a code appearing on the hunter certificate.',
    boite: {
      poisson: 'Box of fish',
      gibier: 'Box of game',
      saumon: 'Box of salmon',
    },
    boutons: {
      connexion: 'Login',
      sauvegarder: 'Save changes',
      supprimer: 'Remove',
      passerCommande: 'Confirm order',
      passerCommandePermis: 'Confirm order',
    },
    oui: 'Yes',
    non: 'No',
    erreur: 'Error',
    succes: 'Success',
    visionnerAssembleeGenerale: 'Watch the general meeting',
    dashboardMessage1: "The Wolastoqiyik Wahsipekuk First Nation (WWFN) is expanding, and several major infrastructure projects are underway, including the Wolastoqey Commercial Hub on the Kataskomiq reserve, the reconstruction of the administrative offices, and the renovation of the Cacouna pub-restaurant. The WFWN must invest a down payment representing at least 10% of the cost of each project, and these amounts cannot be withdrawn from the WFWN's working capital without involving current operations.",
    dashboardMessage2: "In 2019, the WFWN reserved an amount of $2,500,000 for, among other things, the development project of the Withworth reserve (now named Kataskomiq) by resolution 2019-08-07-02. The time has come to use the reserved funds for these projects, which are major for the future of the WFWN.",
    dashboardMessage3: "In accordance with article 10.9 of the WFWN's Financial Policy (2023), the Grand Council adopted a resolution that it shared with the Finance and Audit Committee as well as with the Council of Elders. This resolution is now published on our website for a period of 30 days, in order to inform the Wolastoqiyik of the intention to withdraw these funds from an investment, for the realization of the projects currently underway.",
    voirDocument: 'View document',
    dashboardDocLink: "/doc_retrait_en.pdf",
    "Paramètres de la distribution communautaire": "Community distribution settings",
  },
  fr: {
    admin: 'Administrateur',
    email: 'Courriel',
    prenom: 'Prénom',
    nom: 'Nom',
    adresse: 'Adresse',
    ville: 'Ville',
    codePostal: 'Code postal',
    pays: 'Pays',
    province: 'Province',
    etat: 'État',
    mobile: 'Mobile',
    telephone: 'Téléphone',
    retourAccueil: "Retour à l'accueil",
    accueil: 'Accueil',
    aPropos: 'À propos',
    infoDC:
      "Prendre note que l'inscription à la distribution communautaire est terminée pour cette année.",
    mesCoupons: 'Mes coupons (distribution communautaire)',
    mesPermis: 'Mes permis (chasse et pêche)',
    commanderPermis: 'Confirmation de la commande',
    distributionCommunautaire: 'Distribution communautaire',
    updateProfile: 'Mettre à jour mon profil',
    inscriptionAssemblee: "Formulaire d'inscription à l'assemblée générale",
    espaceVideo: 'Espace vidéo',
    elections: 'Élections',
    monCouponPromo: 'Mon code promo',
    importationCouponsPromo: 'Importation de coupons promo',
    reponsesCandidatsElections: 'Réponses des candidats',
    confirmationCommande: 'Confirmation de la commande',
    monProfil: 'Mon profil',
    deconnexion: 'Déconnexion',
    merci: 'Merci',
    erreurPaiement:
      'Une erreur est survenue, veuillez contacter un membre de notre équipe.',
    noCertificat: 'No. de certificat du chasseur',
    noCodeCertificat: 'Code apparaissant sur le certificat du chasseur',
    erreurNoCertificat: 'Veuillez entrer un numéro de certificat.',
    erreurNoCodeCertificat: 'Veuillez entrer un code apparaissant sur le certificat du chasseur.',
    boite: {
      poisson: 'Boîte de poisson',
      gibier: 'Boîte de gibier',
      saumon: 'Boîte de saumon',
    },
    boutons: {
      connexion: 'Se connecter',
      sauvegarder: 'Sauvegarder',
      supprimer: 'Supprimer',
      passerCommande: 'Confirmer la commande',
      passerCommandePermis: 'Passer la commande',
    },
    oui: 'Oui',
    non: 'Non',
    erreur: 'Erreur',
    succes: 'Succès',
    visionnerAssembleeGenerale: "Visionner l'assemblée générale",
    dashboardMessage1: "La Première Nation Wolastoqiyik Wahsipekuk (PNWW) est en pleine expansion, et plusieurs projets d’infrastructure majeurs sont en cours, notamment le Carrefour commercial Wolastoqey sur la réserve de Kataskomiq, la reconstruction des bureaux administratifs et la rénovation du resto-pub de Cacouna. La PNWW doit investir une mise de fonds représentant au minimum 10 % du coût de chaque projet, et ces montants ne peuvent être retirés du fonds de roulement de la PNWW sans impliquer les opérations courantes.",
    dashboardMessage2: "En 2019, la PNWW a réservé un montant de 2 500 000 $ pour, entre autres, le projet de développement de la réserve de Withworth (maintenant nommée Kataskomiq) par la résolution 2019-08-07-02. Le temps est désormais venu d’utiliser les sommes mises en réserve pour la réalisation de ces projets, qui sont majeurs pour l’avenir de la PNWW.",
    dashboardMessage3: "Conformément avec l’article 10.9 de la Politique financière (2023) de la PNWW, le Grand Conseil a adopté une résolution qu’il a partagée avec le Comité des finances et d’audit ainsi qu’avec le Conseil des Sages. Cette résolution est maintenant publiée sur notre site Web pour une période de 30 jours, afin d’informer les Wolastoqiyik de l’intention de retirer ces fonds d’un placement, pour la réalisation des projets actuellement en cours.",
    voirDocument: 'Voir le document',
    dashboardDocLink: "/doc_retrait.pdf"
  },
};
